/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_HowInputs */



/**
* | output |
* | --- |
* | "How do you want to practise?" |
*
* @param {Practice_Session_HowInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_how = /** @type {((inputs?: Practice_Session_HowInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_HowInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hoe wil je oefenen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment voulez-vous vous entraîner ?")
	return /** @type {LocalizedString} */ ("How do you want to practise?")
});